import { Switch, useParams } from 'react-router-dom';
import Route from './Route';

import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import RecuperarSenha from '../pages/Login/RecuperarSenha';
import CadastrarSenha from '../pages/CadastrarSenha';
import AnaliseSolo from '../pages/AnaliseSolo';
import AnaliseSoloLaudo from '../pages/AnaliseSoloLaudo';
import AnaliseSoloResultado from '../pages/AnaliseSoloResultado';
import UtilizarAnaliseExistente from '../pages/UtilizarAnaliseExistente';
import Perfil from '../pages/Perfil';


//import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

export default function Routes(){

    const {id} = useParams();

    return (
        <Switch basename="/">
            <Route exact path="/" component={Login} />
            <Route exact path="/cadastrar-senha" component={CadastrarSenha} />
            <Route exact path="/login/recuperar-senha" component={RecuperarSenha} />
            <Route exact path="/dashboard" component={Dashboard} isPrivate />
            <Route exact path="/analise-solo" component={AnaliseSolo} isPrivate />
            <Route exact path="/analise-solo/resultado" component={AnaliseSoloResultado} isPrivate />
            <Route exact path="/analise-solo/laudo" component={AnaliseSoloLaudo} id={id ? Number.parseInt(id, 10) : null} isPrivate />
            <Route exact path="/nova-analise" component={UtilizarAnaliseExistente} isPrivate />
            <Route exact path="/perfil" component={Perfil} isPrivate />
        </Switch>
    )
}